'use client'

import React from 'react'

type Props = {
    baseA: number
    baseB: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function TrapezoidChart({ baseA, baseB, height }: Props) {
    const maxDim = Math.max(baseA, baseB, 0.0001)
    const scale = 160 / maxDim
    const a = Math.max(baseA * scale, 20) // bottom (longer base, typically)
    const b = Math.max(baseB * scale, 20) // top
    const h = Math.min(Math.max(height * scale, 40), 110)

    const cx = WIDTH / 2
    const yTop = (HEIGHT - h) / 2
    const yBottom = yTop + h

    const A = [cx - a / 2, yBottom]
    const B = [cx + a / 2, yBottom]
    const C = [cx + b / 2, yTop]
    const D = [cx - b / 2, yTop]

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={`${A.join(',')} ${B.join(',')} ${C.join(',')} ${D.join(',')}`} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx} y1={yTop} x2={cx} y2={yBottom} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <text x={cx} y={yTop - 10} fontSize={12} textAnchor="middle" fill="#374151">b = {baseB.toFixed(2)}</text>
            <text x={cx} y={yBottom + 20} fontSize={12} textAnchor="middle" fill="#374151">a = {baseA.toFixed(2)}</text>
            <text x={cx + 12} y={(yTop + yBottom) / 2} fontSize={12} textAnchor="start" fill="#374151">h = {height.toFixed(2)}</text>
        </svg>
    )
}
